export default function AboutLive() {
  const topics = [
    'Como funciona a tecnologia Mix Express',
    'Para quais clientes ela é indicada',
    'Como aplicar no dia a dia do salão',
    'Como transformar essa solução em diferencial competitivo',
    'Como se posicionar nesse novo movimento do mercado'
  ];

  return (
    <section className="bg-gradient-to-b from-[#2A2A2A] to-[#1A1A1A] py-16 sm:py-24 md:py-28 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#EA9D00]/8 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-8 sm:gap-12 items-center">
          <div className="md:col-span-3">
            <div className="inline-block mb-4 px-4 py-1.5 bg-[#EA9D00] rounded-full">
              <span className="text-[#2A2A2A] font-bold text-sm">100% GRATUITA</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              SOBRE A LIVE
            </h2>
            <div className="text-6xl sm:text-7xl md:text-8xl font-black text-[#EA9D00]">
              09/02
            </div>
          </div>

          <div className="md:col-span-9">
            <p className="text-white text-base sm:text-lg md:text-xl mb-6 sm:mb-8">
              Nesta <strong className="text-[#EA9D00]">live exclusiva e gratuita</strong>, você vai entender:
            </p>

            <div className="space-y-4 sm:space-y-6">
              {topics.map((topic, index) => (
                <div key={index}>
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-[#EA9D00] text-xl sm:text-2xl"></i>
                    </div>
                    <p className="text-white text-base sm:text-lg md:text-xl leading-relaxed">{topic}</p>
                  </div>
                  {index < topics.length - 1 && (
                    <div className="h-px bg-white/10 mt-4 sm:mt-6"></div>
                  )}
                </div>
              ))}
            </div>

            <a
              href="https://chat.whatsapp.com/HlxOc0MOTd992aTE1YYBIN?mode=gi_t"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-8 sm:mt-12 bg-[#EA9D00] text-[#2A2A2A] font-bold text-sm sm:text-base md:text-lg px-6 sm:px-10 md:px-12 py-3 sm:py-4 rounded-full hover:bg-[#d89000] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              GARANTIR MINHA VAGA GRATUITA
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
